<template>
    <SecondaryPage :showLangSwitchBtn="false">
        <div class="max-w-sm m-auto p-6">
            <div class="text-18 font-bold text-a-brown-502314 text-center">
                {{lbl.register.reset_password.title}}
            </div>
            <div class="text-center text-a-brown-502314 text-14 mt-3 mb-6">
                {{lbl.register.reset_password.msg}}
            </div>
            <InputContactNumber
                    v-model:inputValue="phone"
                    :minLength="12"
                    :maxLength="12"
                    delimeter="-"
                    :errorInfo="errorInfo[0]"
                    :isShowError="false"
                    :isSubmitted="false"
                    :inputLbl="lbl.register.contactNumber"
            ></InputContactNumber>
            <InputCalendar
                    v-model:inputValue="birthdate"
                    :inputLbl="lbl.register.birthdate"
                    :errorInfo="errorInfo[1]"
                    :isShowError="false"
                    :isSubmitted="false"
                    @onDateChange="onSelectBirthdate($event)"
            ></InputCalendar>
            <div class="max-w-255px m-auto mt-6">
                <RedButton @click="clickSubmit()">{{lbl.register.reset_password.send}}</RedButton>
            </div>
        </div>
    </SecondaryPage>
</template>
<script>
import { FormHelper } from '@/helper/FormHelper'
//component
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue'
import InputCalendar from '@/components/Input/label/InputCalendar.vue'
import RedButton from '@/components/Button/RedButton.vue'
//mixin
import LocaleMixin from '@/mixin/LocaleMixin'
import ModalMixin from '@/mixin/ModalMixin'
//service
import ResetPasswordApi from '../service/ResetPasswordApi'

export default {
    mixins: [LocaleMixin, ModalMixin],
    components: {
        SecondaryPage,
        InputContactNumber,
        InputCalendar,
        RedButton,
    },
    data: function () {
        return {
            phone: '',
            birthdate: '',
            birthdateTimestamp: null,

            errorInfo: FormHelper.genErrorInfo(2),
        };
    },
    methods: {
        onSelectBirthdate: function (data) {
            this.birthdateTimestamp = data.timestamp;
        },
        clickSubmit: function () {
            if (this.validateForm()) {
                console.log('submit');
                this.modal.confirmResetPasswordModal.clearModal().show();
                this.modal.confirmResetPasswordModal.onClickMobile(() => {
                    this.sendResetPassword('sms');
                });
                this.modal.confirmResetPasswordModal.onClickEmail(() => {
                    this.sendResetPassword('email');
                });
            }
        },
        validateForm: function () {
            return FormHelper.validate(this.errorInfo);
        },

        sendResetPassword: async function (type) {
            this.modal.loadingModal.show();
            let rs = await this.apiResetPassword(type);
            this.modal.loadingModal.hide();

            if (rs) {
                // let successMsg = (type == 'sms') ?
                //     'Reset Password link has been sent.<br>Please check your mobile no.' :
                //     'Reset Password link has been sent.<br>Please check your email.';

                // show success
                this.modal.successModal.clearModal()
                    .setMsg(this.lbl.register.reset_password.success)
                    .show()
                this.modal.successModal.onClose(() => {
                    this.$router.replace('/home');
                });
            }
        },

        apiResetPassword: function (type) {
            return new Promise((resolve) => {
                ResetPasswordApi.apiResetPassword(type, this.phone, this.birthdateTimestamp).subscribe({
                    next: (data) => {
                        
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(false);
                        if (err.message == "Birthdate is mismatch") {
                            this.modal.errorModal
                                .clearModal()
                                .setMsg(this.lbl.register.reset_password.birthdate_not_match)
                                .show();
                        } else {
                            this.errorApi(err);
                        }                      
                    },
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
